import React from 'react';
import Switch from '../Switch';

interface FormSwitchProps {
  form: any;
  name: string;
  label?: string | React.ReactNode;
  subLabel?: string;
  disabled?: boolean;
  className?: string;
}

export const FormSwitch: React.FC<FormSwitchProps> = ({
  form,
  name,
  label,
  subLabel,
  disabled = false,
  className = '',
}) => {
  return (
    <form.Field
      name={name}
      children={(field: any) => {
        return (
          <div className={`form-element ${className}`}>
            {label && (
              <label htmlFor={name} className="label">
                <div>{label}</div>
                {subLabel && <div className="sub-label">{subLabel}</div>}
              </label>
            )}
            <Switch
              id={name}
              value={field.state.value || false}
              onChange={(value: boolean) => field.handleChange(value)}
              isDisabled={disabled}
            />
          </div>
        );
      }}
    />
  );
};